import { Component } from '@angular/core';

@Component({
  selector: 'tx-websocket-closed-dialog',
  templateUrl: './websocket-closed-dialog.component.html',
  styleUrls: ['./websocket-closed-dialog.component.scss']
})
export class WebsocketClosedDialogComponent {

}
